// Behaviour shared by every page around the static header and footer: the theme button, the language switch
// remembers the choice, the ads (src/ads/ads.ts) as the launch, Remove Ads and the visitor's consent decide, both ways
// (a period starting removes them; its end or a refund brings back what the consent says), and the header shows the
// account link.
import { startAds, type AdController } from '../ads/ads';
import { startAdsNotice } from './ads-notice';
import { startAccountLink } from './account-link';
import { startTheme } from './theme';

const languageKey = 'chordToMidi.lang';

function rememberLanguageChoice() {
  for (const link of document.querySelectorAll<HTMLAnchorElement>('a[data-lang]')) {
    link.addEventListener('click', () => {
      try {
        localStorage.setItem(languageKey, link.dataset.lang ?? 'en');
      } catch {
        // The choice isn't remembered; the link still works.
      }
    });
  }
}

export function startPage(): void {
  // First: it needs nothing from the network.
  startTheme();
  startAdsNotice();
  rememberLanguageChoice();
  let ads: AdController | null = null;
  const adFreeNow = startAccountLink((adFree) => ads?.setAdFree(adFree));
  ads = startAds(adFreeNow);
}
